module.exports = require("./az-Latn.d.ts");